/*
 * @Author: chenliang
 * @Date: 2020-12-08 09:40:29
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-25 22:20:14
 * @Description: 首页
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card , Tabs , Button } from 'antd'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import moment from 'moment';
 

const bodyStyle = {
    bodyStyle: {
      height: 432,
      background: '#fff',
    },
}

const { TabPane } = Tabs;

const Color = {
    green: '#64ea91',
    blue: '#8fc9fb',
    purple: '#d897eb',
    red: '#f69899',
    yellow: '#f8c82e',
    peach: '#f797d6',
    borderBase: '#e5e5e5',
    borderSplit: '#f4f4f4',
    grass: '#d6fbb5',
    sky: '#c1e0fc',
}

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
      showTab:1,
  }

  componentDidMount(){
      const { history} = this.props;
      let token = sessionStorage.getItem("token");
      console.log('token' , token);
      if (token == '' || token == null || token == undefined) {
        this.props.history.push('/login')
      }
  }

  get countCardProps(){
      const {home} = this.props;
      const {
        companyAll,
        companyToday,
        positionAll,
        positionToday,
        userAll,
        userToday,
      } = home;
      return {
        companyAll,
        companyToday,
        positionAll,
        positionToday,
        userAll,
        userToday,
        tabValue:this.state.showTab,
        onTabChange:(tabvalue) => {this.setState({showTab:tabvalue})}
      }
  }

  get chartProps(){
    const {home} = this.props;
    const {
        hotByPositionType,
        countByPositionType,
        hotByArea,
    } = home;
    return {
        hotByPositionType,
        countByPositionType,
        hotByArea,
    }
  }

  get chart2Props(){
    const {home} = this.props;
    const {
        countByAge,
        countByEdu,
        countByGender,
    } = home;
    return {
        countByAge,
        countByEdu,
        countByGender,
    }
  }


  get SendPositionListProps() {
    const {home} = this.props;
    const { sendPositionList } = home;
    return {
      sendPositionList
    }
  }


  get UserBrowerListProps() {
    const { home } = this.props;
    const {userBrowerList} = home;
    return {
      userBrowerList
    }
  }


  get PositionBrowerListProps() {
    const { home } = this.props;
    const {positionBrowerList} = home;
    return {
      positionBrowerList
    }
  }


  search = () => {

  }


  render() {
       

    return (
      <div className="home-default-page">
 
        

          <Button onClick={this.search}>公共查询</Button>
        

      


      
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js